function merge(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var defaults=arguments.length>1?arguments[1]:undefined;for(var key in defaults){if(typeof obj[key]==="undefined"){obj[key]=defaults[key];}}return obj}

export { merge as default };
//# sourceMappingURL=merge.js.map
